import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/evaluationService";
const store = {};
const mutations = {
    GET_EVALUATION_OVERVIEW(state, posts) {
        state.evaluationOverviewList = posts;
        state.evaluationOverviewListIsLoading = false;
    },
};
const state = {
    evaluationOverviewList: [],
    evaluationOverviewListIsLoading: false
};
const getters = {};
const actions = {
    getEvaluationOverview({ commit }, { RtgId }) {
        state.evaluationOverviewListIsLoading = true;
        axios
            .get(baseUri + '/GetVotingOverview?RtgId=' + RtgId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_EVALUATION_OVERVIEW', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}